import(/* webpackMode: "eager" */ "/vercel/path0/apps/repetix/app/docs/page.tsx");
